import styled from "styled-components";

export const TabelaContainer = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 0.5rem;
`;

export const TabelaHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 80px;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 0.85rem;
  border-bottom: 1px solid #dee2e6;

  span {
    padding: 8px 12px;
    border-right: 1px solid #dee2e6;
  }
  span:last-child {
    border-right: none;
  }
`;

export const TabelaLinha = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 80px;
  align-items: stretch;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
`;

export const CustoNome = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  padding: 6px 12px;
  border-right: 1px solid #f0f0f0;
`;

export const InputTabela = styled.input`
  border: none;
  border-right: 1px solid #f0f0f0;
  background: transparent;
  padding: 6px 12px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;

  &::placeholder {
    color: #adb5bd;
  }

  &:hover:not(:focus) {
    background: #f8f9fa;
  }

  &:focus {
    outline: none;
    cursor: text;
    background: #fff;
  }
`;

export const BotaoRemover = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #000;
  font-size: 1rem;
  padding: 6px 12px;
`;
